import { render, staticRenderFns } from "./AdvertisingCampaign.vue?vue&type=template&id=cd29b530&scoped=true"
import script from "./AdvertisingCampaign.vue?vue&type=script&lang=js"
export * from "./AdvertisingCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd29b530",
  null
  
)

export default component.exports